<template>
    <div class="saveOrUpdateCrud">
        <div>
            <el-page-header @back="close" content="考场贴详情"></el-page-header>
        </div>
        <div style="width: 100%;float: right;text-align: right;margin-right: 20px;margin-bottom: 20px">
            <el-button size="mini" plain type="primary" icon="el-icon-download" v-display:examRoomDoorPrintLook-img @click="downloadResult('page')" >导出图片考场贴</el-button>
            <el-button size="mini" plain type="primary" icon="el-icon-download" v-display:examRoomDoorPrintLook-pdf @click="printOutpdf('page')">导出PDF考场贴</el-button>
            <el-button size="mini" plain type="primary" icon="el-icon-download" v-display:examRoomDoorPrintLook-pdf v-print="`#page`">在线打印</el-button>
        </div>
        <div style="margin-bottom: 40px;height: auto;" class="page" id="page">
            <div class="subpage" style="margin-top: -100px">
                <div style="height: 330px;width: 100%;margin-top: 0px">
                    <div style="font-size: 34px;text-align: center;font-weight: bold;margin-bottom: 40px">武汉晴川学院  {{new Date().getFullYear()}}  年普通专升本招生考试</div>
                    <div style="margin-bottom: 20px;width: 100%" v-for="items in examRooForm.sysMajorList">
                        <div style="font-size: 30px;text-align: center;font-weight: bold;line-height: 60px">{{items.name}}</div>
                        <div style="font-size: 22px;text-align: center;height:80px;width:100%;font-weight: 400" cellspacing="0" cellpadding="0"  align="center">
                            <div v-for="item in items.sysMajorItemList" style="width: 100%;height: 50px;line-height: 50px">
                                <div style="text-align: center;width: 50%;float: left">{{item.name}}</div>
                                <div style="text-align: center;width: 50%;float: left">{{item.examDay}}<span style="margin-left: 5px"> {{item.examStartTime.substring(0,5)}}~{{item.examEndTime.substring(0,5)}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div style="font-size: 30px;text-align: center;font-weight: bold;margin-top: 60px;height: 50px;line-height: 50px">
                        准考证起始：{{examRooForm.minTicket}}~{{examRooForm.maxTicket}}
                    </div>
                    <div style="font-size: 146px;text-align: center;font-weight: bold;margin-top: 100px">
                        第{{examRooForm.examRoomNum}}考场
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    let loading;
    export default {
        name: "examRoomDoorPrintLook",
        props:["examRoomNum","classroomNum"],
        data(){
            return {
                examRoomList:[],
                examRoomStudentList:[],
                roomName:'',
                config:config,
                examRooForm:{},
            }
        },
        created(){
            this.getExamRoomStudent(this.examRoomNum,this.classroomNum)
        },
        mounted(){
        },
        methods:{
            getExamRoomStudent(roomCode,classroomNum){
                axios({
                    url:`${home}/sysExamRoom/findTicketListByStudents`,
                    method:'POST',
                    data:{
                        "examRoomNum":roomCode,
                        "classroomNum":classroomNum
                    }
                }).then(res=>{
                    this.examRooForm = res.data;
                    this.roomName = classroomNum;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getBase64Img(){
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);
                var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                var dataURL = canvas.toDataURL("image/" + ext);
                return dataURL;
            },
            base64ImgtoFile(dataurl, filename = 'file') {
                let arr = dataurl.split(',')
                let mime = arr[0].match(/:(.*?);/)[1]
                let suffix = mime.split('/')[1]
                let bstr = atob(arr[1])
                let n = bstr.length
                let u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], `${filename}.${suffix}`, {
                    type: mime
                })
            },
            close(){
                this.$emit('closeExamRoomDoorPrintLook');
            },
            dataURLToBlob(dataurl) {//ie 图片转格式
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime})
            },
            downloadResult(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let canvasID = document.getElementById(name);
                let a = document.createElement('a');
                html2canvas(canvasID).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = "none";
                    a.style.display = "none";
                    document.body.removeChild(dom);
                    let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                    a.setAttribute("href", URL.createObjectURL(blob));
                    a.setAttribute("download", "第"+this.examRoomNum + "考场门贴.png")
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                });
                loading.close();
            },
            /**
             *
             * @param url 图片路径
             * @param ext 图片格式
             * @param callback 结果回调
             */
            getUrlBase64(url, ext, callback) {
                var canvas = document.createElement("canvas");   //创建canvas DOM元素
                var ctx = canvas.getContext("2d");
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = function () {
                    canvas.height = 150; //指定画板的高度,自定义
                    canvas.width = 130; //指定画板的宽度，自定义
                    ctx.drawImage(img, 0, 0, 150, 130); //参数可自定义
                    var dataURL = canvas.toDataURL("image/" + ext);
                    callback.call(this, dataURL); //回掉函数获取Base64编码
                    canvas = null;
                };

            },
            printOut(name) {
                // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
                $(window).scrollTop(0); // jQuery 的方法
                document.body.scrollTop = 0; // IE的
                document.documentElement.scrollTop = 0; // 其他
                this.downloadResult(name)
            },
            printOutpdf(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let shareContent = document.getElementById(name),//需要截图的包裹的（原生的）DOM 对象
                    width = shareContent.clientWidth, //获取dom 宽度
                    height = shareContent.clientHeight, //获取dom 高度
                    canvas = document.createElement("canvas"), //创建一个canvas节点
                    scale = 2; //定义任意放大倍数 支持小数
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.style.width = shareContent.clientWidth * scale + "px";
                canvas.style.height = shareContent.clientHeight * scale + "px";
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                console.log(height+'======'+width);
                let opts = {
                    scale: scale, // 添加的scale 参数
                    canvas: canvas, //自定义 canvas
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    width: width, //dom 原始宽度
                    height: height,
                    useCORS: true, // 【重要】开启跨域配置
                };
                html2canvas(shareContent).then(canvas => {
                    var contentWidth = canvas.width;
                    var contentHeight = canvas.height;
                    //一页pdf显示html页面生成的canvas高度;
                    var pageHeight = (contentWidth / 592.28) * 841.89;
                    console.log(pageHeight);
                    //未生成pdf的html页面高度
                    var leftHeight = contentHeight;
                    //页面偏移
                    var position = 0;
                    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    var imgWidth = 595.28;
                    var imgHeight = (592.28 / contentWidth) * contentHeight;
                    console.log(imgHeight);
                    var pageData = canvas.toDataURL("image/jpeg", 1.0);
                    var PDF = new JsPDF("", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save("第"+this.examRoomNum + "考场门贴.pdf"); // 这里是导出的文件名
                    loading.close();
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }

    .page {
        width: 21cm;
        min-height: 29.7cm;
        padding: 2cm;
        margin: 1cm auto;
        border-radius: 5px;
        background: white;
    }

    .subpage {
        padding: 1cm;
        height: 256mm;
    }

    .pageStyle {
        float: left;
        height: 275px;
        width: 46%;
        margin-top: 45px;
        margin-left: 30px;
    }
    .schoolProcessList {
        margin-top: 20px;
        list-style: none;
        // height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        margin-left: -4%;
        // margin-top: -5%;
        // align-content: space-around;
        li {
            border-radius: 6px;
            background: #ECF9F9;
            margin-left: 4%;
            // margin-top: 5%;
            width: 12.6%;
            text-align: center;
            margin-bottom: 4%;
            img {
                margin: 12% auto 10%;
                width: 55%;
            }
            .oa-btn .el-button {
                min-width: 60%;
                max-width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-left: 5%;
                padding-right: 5%;
                margin-bottom: 18%;
                border-radius: 50px;
                padding-top: 4.5%;
                padding-bottom: 4.5%;

            }
        }
    }

</style>